import React from "react";
import { ToastContainer } from "react-toastify";
import { AddCategory } from "../../../components/MasterSettings/Category/AddCategory";
export const CategoryAdd = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddCategory />
        </div>
      </div>
    </div>
  );
};